import * as React from "react";
import { v4 } from "uuid";

import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';

import "./../../resources/forest.jpg";

import { ThemeProvider } from '@material-ui/core/styles';

import { createMuiTheme } from '@material-ui/core/styles';
import red from '@material-ui/core/colors/red';
import {ExerciseTask, TaskOption, ExerciseType} from '../server/ExamServer'
import ExamOption from "./ExamOption";
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import Avatar from '@material-ui/core/Avatar';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';

const theme = createMuiTheme({
    palette: {
        // primary: {
        //     main: '#44423e'
        // },
        // secondary: {
        //     main: '#FDC400',
        //     contrastText: '#fff'
        // }
    }

});

export interface ExamTaskProps {
    task:ExerciseTask
    type:ExerciseType
    index:number
    onSelect:(option: TaskOption, task:ExerciseTask) => void
}

export interface ExamTaskState {

}


class ExamTask extends React.Component<ExamTaskProps, ExamTaskState> {


    constructor(props: ExamTaskProps) {
        super(props);
    }

    handleSelect = (option: TaskOption) => {
        this.props.onSelect && this.props.onSelect(option, this.props.task);
    }
    


    render() {

        const {task,type, index} = this.props

        let question;  

        const checkedOption:Array<TaskOption> = task.options.filter(option =>{return option.checked === true});

        if(checkedOption.length>0){
            let splittedQuestion:Array<string> = task.content.split("{PLACEHOLDER}")
            question = <Typography style={{
                    margin:theme.spacing(1),
                    marginTop:theme.spacing(1.7),
                    fontSize:17,
                    whiteSpace:"pre-wrap"
                }}
                variant="body1" color="textPrimary" component="h5">
                    
                    {splittedQuestion.map((qPart, i)=>{
                        if(i===0){
                            return qPart
                        }
                        else{
                            return (<React.Fragment><u>{(i===1)?checkedOption[0].content : checkedOption[0].content2}</u>{qPart}</React.Fragment>)
                        }
                        
                    })}
            </Typography>
        }
        else {
            
            question = <Typography style={{
                    margin:theme.spacing(1),
                    marginTop:theme.spacing(1.7),
                    fontSize:17,
                    whiteSpace:"pre-wrap"
                }}
                variant="body1" color="textPrimary" component="h5">
                    {task.content.replace("{PLACEHOLDER}","_________").replace("{PLACEHOLDER}","_________")}
            </Typography>   

        }


        return (
            <Paper elevation={0} style={{padding:theme.spacing(1), marginTop:theme.spacing(3),  display:"flex"}}>
                
               
                <Avatar style={{
                    width:theme.spacing(4),
                    height:theme.spacing(4),
                    margin:theme.spacing(1),
                    fontSize:theme.typography.body1.fontSize,
                    backgroundColor:((checkedOption.length>0)?theme.palette.grey[400]:theme.palette.primary.main)
                }}>{index+1}</Avatar>


                <div style={{flexGrow:1}} >
                    {question}

                    {type===ExerciseType.Check?(
                        <FormControl component="fieldset" >
                            <FormGroup>
                            {task.options.map(option =>{
                                return <ExamOption type={type} option={option} disabled={false} onSelect={this.handleSelect} />
                            })}
                            </FormGroup>
                        </FormControl>
                    ):null}
                    
                    {type===ExerciseType.Multi?(
                        <React.Fragment>
                            {task.options.map(option =>{
                                return <ExamOption type={type} option={option} disabled={false} onSelect={this.handleSelect} />
                            })}
                        </React.Fragment>
                            
                    ):null}
                </div>
            </Paper>

        );
    }
}

export default ExamTask;
